import React from 'react';
import LoyaltyBadgeWrapper from '@/app/common/components/LoyaltyBadge';

const LoyaltyBadge = () => <LoyaltyBadgeWrapper label={''} />;

export default LoyaltyBadge;
